module.exports = __webpack_public_path__ + "389B5D_0_0.ttf";